/*
 * @Author: 大侠传授两招吧
 * @Date: 2022-03-19 23:41:35
 * @LastEditors: 大侠传授两招吧
 * @LastEditTime: 2022-03-29 19:05:05
 * @Description: 
 */
import EventBus from './../utils/eventBus'
export default{//同步直接修改state里面的值
    getUserInfo(state,info){
      //第一个参数是state 第二个参数是调用mutations传入的参数
        state.userInfo = info;
        if(JSON.stringify(info) == "{}"){
          EventBus.$emit('loginOut');
        }
    },
    setInfofold(state, payload) {
      return state.infofold = payload
    },
    setVisitorChat(state, payload) {
      return state.visitor_chat = payload
    },
    setMessage(state, payload) {
      return state.message = payload
    },
    setNotices(state, payload) {
      return state.notices = payload
    },
    setDownloadImg(state, payload){//下载app二维码
      return state.downloadImg = payload;
    },
    setSocket(state, payload) {
      return state.socket = payload
    },
    setSocketMsg(state, payload) {
      return state.socketMsg = payload
    },
    setGiftList(state, payload) {
      return state.giftList = payload
    },
    setSocketUrl(state, payload) {
      return state.socketUrl = payload
    },
    setConfigMutation(state, payload) {
        state.config = payload;
    },
    setSportType(state, payload) {
      state.sportType = payload;
    },
    setRoomService(state, payload) {
      state.room_service_url = payload;
    }
    
}


// WEBPACK FOOTER //
// ./src/store/mutations.js